import { useNavigate as useReactRouterNavigate } from "react-router-dom";

const PREFIX = "/jainboarding-admin";

/**
 * Custom navigate hook that automatically prefixes all paths with /jainboarding-admin
 */
export const usePrefixedNavigate = () => {
  const navigate = useReactRouterNavigate();

  return (
    to: string | number,
    options?: { replace?: boolean; state?: any }
  ) => {
    if (typeof to === "number") {
      // For relative navigation (back/forward)
      navigate(to);
      return;
    }

    // If the path already starts with the prefix, use it as is
    if (to.startsWith(PREFIX)) {
      navigate(to, options);
      return;
    }

    // If the path starts with /, prefix it
    if (to.startsWith("/")) {
      navigate(`${PREFIX}${to}`, options);
      return;
    }

    // For relative paths, prefix them
    navigate(`${PREFIX}/${to}`, options);
  };
};
